<template>
  <div class="dimmed">
    <content-box class="cannot-preview--wrap" width="430px">
      <i class="icon icon--dialog-warning"></i>
      <p class="desc desc1" v-html="$t('page.cannotPreview.desc1')"></p>
      <img v-if="currentLang === 'ko'" src="../../assets/img/page/cannot_preview_ko.png" alt="">
      <img v-else-if="currentLang === 'ja'" src="../../assets/img/page/cannot_preview_ja.png" alt="">
      <img v-else src="../../assets/img/page/cannot_preview_en.png" alt="">
      <p class="desc desc2" v-html="$t('page.cannotPreview.desc2')"></p>
      <ui-button @click="$emit('onCloseClick')">
        {{ $t('common.confirm') }}
      </ui-button>
    </content-box>
  </div>
</template>

<script>
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'

export default {
  name: 'cannotPreview',
  components: {
    ContentBox,
    UiButton
  },
  computed: {
    currentLang () {
      return this.$i18n.locale
    }
  }
}
</script>

<style lang="scss" scoped>
.cannot-preview--wrap {
  width: 430px;
  text-align: center;
  padding: 29px 40px 25px 40px;
  box-sizing: border-box;
  @include positionXYcenter;

  .desc {
    font-size: 14px;
    line-height: 1.43;
    color: #2f2f2f;

    &.desc1 {
      padding: 14px 0 23px 0;
    }

    &.desc2 {
      padding: 26px 0 25px 0;
    }
  }

  img {
    width: 358px;
  }
}
</style>
